import { request } from '../helpers/request';
import { htmlMsg, simpleMsg, valMsg } from '../helpers/swal_msg';

// enviar correo de contacto a destinatario predeterminado
export const sendContactEmail = async(data, setData) => {
    try {
        const resp = await request('form/contact', data, 'POST');
        const body = await resp.json();
        if (body.status) {
            simpleMsg('success', 'Mensaje enviado');
            setData(e => ({
                ...e, name: '',
                email: '', msg: ''
            }));
        } else {
            if (body.msg === 'miss') {
                let txt = 'Revise la información del formulario';
                if (body.resp.errors) {
                    txt = '<div style="text-align: left; padding-left: 0pt;"><div><p>Revise los campos: </p><ul>';
                    for (const e of body.resp.errors) {
                        txt += `<li>${e}</li>`;
                    };
                    txt += '</ul></div></div>';
                }
                htmlMsg('warning', 'Mensaje no enviado', txt);
            } else if (body.msg === 'email-not-sent')
                simpleMsg('warning', 'No se ha enviado el mensaje');
            else if (body.msg === 'server-err')
                simpleMsg('error', 'Incidente al enviar mensaje');
            else
                simpleMsg('info', 'Mensaje no enviado');
        }
    } catch (err) {
        valMsg('error', 'Mensaje no enviado',
        'Problema con el formulario');
    };
};

// enviar correo de cotización a destinatario predeterminado
export const sendQuoteEmail = async(data, setData) => {
    try {
        const resp = await request('form/quote', data, 'POST');
        const body = await resp.json();
        if (body.status) {
            simpleMsg('success', 'Mensaje enviado');
            setData(e => ({
                ...e, name: '',
                email: '', msg: ''
            }));
        } else {
            if (body.msg === 'miss') {
                let txt = 'Revise la información del formulario';
                if (body.resp.errors) {
                    txt = '<div style="text-align: left; padding-left: 0pt;"><div><p>Revise los campos: </p><ul>';
                    for (const e of body.resp.errors) {
                        txt += `<li>${e}</li>`;
                    };
                    txt += '</ul></div></div>';
                }
                htmlMsg('warning', 'Mensaje no enviado', txt);
            } else if (body.msg === 'email-not-sent')
                simpleMsg('warning', 'No se ha enviado el mensaje');
            else if (body.msg === 'server-err')
                simpleMsg('error', 'Incidente al enviar mensaje');
            else
                simpleMsg('info', 'Mensaje no enviado');
        }
    } catch (err) {
        valMsg('error', 'Mensaje no enviado',
        'Problema con el formulario');
    };
};